<template>
  <div class="bg-light py-4" style="min-height: 100vh;">
    <div class="container" v-if="schoolData">
      <div class="pt-1 pb-4">
        <div class="d-flex align-items-center justify-content-center mt-auto">
          <img v-if="schoolData.name" :src="schoolData.logo" :alt="schoolData.name" style="width:70px;" />
          <img v-else src="/resources/images/air-logo.png" alt="neoskool" />
          <div class="ml-3">
            <div class="h5 font-weight-bold text-dark mb-0">{{ schoolData.name ? schoolData.name : 'skoolsync-M'}}</div>
            <div
              class="font-size-12 text-gray-6"
            >{{ schoolData.contact ? `${schoolData.contact.address}, ${schoolData.contact.city}` : '' }}</div>
          </div>
        </div>
      </div>
      <a-divider />
      <div class="mt-3">
        <div class="air__utils__heading">
          <div class="row">
            <div class="col-sm-6">
              <h5>Pay Student Fees</h5>
            </div>
          </div>
        </div>
        <a-spin :spinning="loading">
          <div>
            <div class="row justify-content-center my-4">
              <div class="col-12 text-center mb-3" v-if="!studentCode">
                <a-tag color="blue">
                  Enter the student code or admission id and click on show fees to view and pay student's fees
                </a-tag>
              </div>
              <div class="col-sm-10 col-md-6">
                <a-input-search
                  placeholder="Student Code or Admission Id"
                  enter-button="Show Fees"
                  size="large"
                  v-model="studentCode"
                  @search="getStudentFees"
                />
              </div>
            </div>
            <div v-if="data">
              <div class="card shadow-sm">
                <div class="card-body">
                  <show-student-fees :data="data" :schoolId="schoolData ? schoolData.id : null" :studentCode="studentCode"/>
                </div>
              </div>
            </div>
            <div v-if="notFound">
              <div class="row justify-content-center">
                <div class="col-12 col-sm-6 mt-3">
                  <a-alert message="Student Information not found" banner />
                </div>
              </div>
            </div>
          </div>
        </a-spin>
      </div>
      <pay-student-fees @paid="handleFeesPaid" :schoolData="schoolData"/>
      <student-fee-payment :is-public="true" :schoolData="schoolData"/>
      <hr>
      <div class="d-flex justify-content-center">
        <div class="col-sm-12 col-md-3">
          <h5> Contact Us</h5>
          <div class="fe fe-phone pt-2"> +91 {{schoolPrivacyPolicy.phone}}</div>
          <div class="fe fe-mail pt-2"> {{schoolPrivacyPolicy.email_id}}</div>
          <div class="fe fe-home pt-2"> {{schoolPrivacyPolicy.address}}</div>
        </div>
        <div class="col-sm-12 col-md-3">
          <ul>
            <li><a v-bind:href="schoolPrivacyPolicy.about_us" target="_blank">About Us</a></li>
            <li><a v-bind:href="schoolPrivacyPolicy.terms_and_conditions" target="_blank">Terms and Conditions</a></li>
            <li><a v-bind:href="schoolPrivacyPolicy.privacy_policy" target="_blank">Privacy Policy</a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from 'moment'
import { mapState } from 'vuex'

import ShowStudentFees from '@/components/public/Fees/Show/index'
import PayStudentFees from '@/components/public/Fees/Pay/index'
import StudentFeePayment from '@/components/feemanagement/payment/Payment/index'

import { feeTypes } from '@/services/globaldata'
import { find } from 'lodash'

const subdomain = window.location.host.split('.')[0]

export default {
  name: 'DisplayStudentsFeesList',
  components: {
    ShowStudentFees,
    PayStudentFees,
    StudentFeePayment,
  },
  mounted: function() {
    this.getSchoolData()
    if (this.$route.query.afterPayment) {
      if (this.$route.query.pay_gateway === 'instamojo') {
        if (this.$route.query.payment_status === 'Credit') {
          this.$success({
            title: 'Fees payed successfully!',
            content: 'You can view the receipt by clicking the Receipt button by the fee shown in the fee table.',
          })
        } else {
          this.$error({
            title: 'Payment failed!',
            content: 'Please do not panic. If your money has been deducted, it will be settled within 5-7 days.',
          })
        }
      } else {
        this.$success({
          title: 'Fees payed successfully!',
          content: 'You can view the receipt by clicking the Receipt button by the fee shown in the fee table.',
        })
      }
    }
  },
  data: function() {
    return {
      feeTypes,
      dateFormat: 'DD-MM-YYYY',
      selectedStudent: this.intialStudent,
      studentCode: this.$route.query.sc,
      schoolData: null,
      data: null,
      notFound: false,
      loading: false,
      schoolPrivacyPolicy: null,
    }
  },
  computed: {
    ...mapState(['settings']),
  },
  watch: {
    data(value) {
      this.$router.push({ name: 'publicpayfees', query: { sc: this.studentCode } })
    },
  },
  methods: {
    moment,
    find,
    handleFeesPaid: function (paymentData) {
      const student = {
        first_name: this.data.student.first_name,
        last_name: this.data.student.last_name,
        student_code: this.data.student_code,
        class_name: this.data.school_class.name,
        section_name: this.data.section.name,
        roll_no: this.data.roll_no,
        id: this.data.student.id,
      }
      this.$eventBus.$emit('openViewStudentFeeReceiptModal', paymentData.student_fee, student)

      this.getStudentFees()
    },
    getStudentFees: function(sc = null) {
      this.data = null
      this.notFound = false
      if (this.studentCode) {
        this.loading = true
        this.notFound = false
        this.$http.get(`/api/school/student/fees`, {
          params: {
            school_id: this.schoolData.id,
            student_code: sc ? this.studentCode : null,
          },
        }).then(({ data }) => {
          this.loading = false

          if (!data.not_found) {
            this.data = data.data
          } else {
            this.notFound = true
          }
        }).catch(error => {
          this.loading = false
          console.log(error)
          this.$neoNotify.error(error)
        })
      } else {
        this.$message.warning('Please enter a student code to view fee details!')
      }
    },
    getSchoolData: function() {
      this.loading = true
      this.$http.get(`/api/school/subdomain/${subdomain}`)
        .then(({ data }) => {
          this.loading = false
          if (data.data.online_payment) {
            this.schoolData = data.data
            this.getSchoolPrivacyPolicy()
            this.$nextTick(() => {
              if (this.$route.query.sc) {
                this.getStudentFees(this.$route.query.sc)
              }
            })
          } else {
            this.$router.push({ name: '404' })
          }
        })
    },
    getSchoolPrivacyPolicy: function() {
      this.loading = true
      this.$http.get(`api/school-privacy-policy/` + this.schoolData.id)
        .then(({ data }) => {
          this.loading = false
          if (data.data != null) {
            this.schoolPrivacyPolicy = data.data
          } else {
            this.$router.push({ name: '404' })
          }
        })
    },
  },
}
</script>
